module.exports = "/packs/images/cross~78afb119d83011ce7f9df777964bdd1e.png";